import { DynamicQueryParam as QueryParam } from "@/constants/query-params";

export const TEST_COMPONENTS_ROUTE_CONFIG = {
  path: "/test-components",
  defaultTabId: "design-system-overview",
  sideNavScrollPositionKey: "test-components-sidebar",
  commandPalette: {
    facet: "test-pages",
    label: "Pages",
    ariaLabel: "Test components command palette",
    placeholder: "Search test components",
  },
} as const;

// Use a dedicated query param rather than a dynamic Next page. Turbopack can
// intermittently drop nested dynamic Pages Router entries from its dev route
// manifest; keeping every pane on the static `/test-components` page avoids
// that 404 mode. This is deliberately NOT `?v=`: panes need `v` for their own
// shared tab viewers.
export const getTestComponentPaneHref = (paneId: string): string =>
  `${TEST_COMPONENTS_ROUTE_CONFIG.path}?${QueryParam.TEST_COMPONENTS_PANE}=${encodeURIComponent(paneId)}`;

export const getTestComponentHref = (tabId: string, viewModeId?: string) =>
  `${getTestComponentPaneHref(tabId)}${
    // Carry the Data selector across pane switches; "loaded" is the default
    // and stays out of the URL.
    viewModeId != null && viewModeId !== "loaded"
      ? `&${QueryParam.TEST_COMPONENTS_DATA_STATE}=${viewModeId}`
      : ""
  }`;
